import { SVGProps } from 'react';

const Youtube = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M21.25 8A3.25 3.25 0 0 0 18 4.75H6A3.25 3.25 0 0 0 2.75 8v8A3.25 3.25 0 0 0 6 19.25h12A3.25 3.25 0 0 0 21.25 16V8Zm-11.62.348a.75.75 0 0 1 .756.008l5 3a.751.751 0 0 1 0 1.288l-5 3A.75.75 0 0 1 9.25 15V9c0-.27.146-.52.38-.652Zm1.12 5.327L13.541 12l-2.791-1.676v3.35Zm12 2.325A4.75 4.75 0 0 1 18 20.75H6A4.75 4.75 0 0 1 1.25 16V8A4.75 4.75 0 0 1 6 3.25h12A4.75 4.75 0 0 1 22.75 8v8Z"
    />
  </svg>
);

export default Youtube;
